import { dateService, FORMATS } from '@/global/services/date'
import documentsHistoryHelper from '../documents-history-helper'
import { isObject } from '@/global/utils/utils'
import tabsHelper from '../tabs-helper'

const DOCUMENTS_HISTORY_DATA_KEY = 'invitationHandoverDocuments'
const DOCUMENT_TYPE = 'excavation_handover_invitation'
export default {

  mixins: [
    documentsHistoryHelper,
    tabsHelper
  ],

  data () {
    return {
      invitationHandoverHistoryVisible: false,
      invitationHandoverDocumentHistoryLoaded: false,
      invitationRefreshDisabled: false,
      ithDocumentLoaders: []
    }
  },

  computed: {
    invitationToHandoverConfig () {
      return {
        title: this.$t('road-maintenance/aggregator.invitation_to_handover'),
        visible: this.$route.query.category !== 'request_new',
        key: 'invitation-to-handover',
        apiConfig: {
          get: {
            module: 'road-maintenance',
            route: `traffic-regulation/${this.$route.params.id}/${DOCUMENT_TYPE}`,
            method: 'get'
          }
        },
        dataFetched: (event) => this.onInvitationHandoverDataFetched(event),
        tabContent: [
          {
            component: this.tabActionsComponent,
            title: this.$t('road-maintenance/aggregator.invitation_to_handover'),
            showBackButton: {
              onGoBack: () => this.goBack()
            },
            forceAdditionalButtonsDisplay: true,
            showEditButtons: false,
            additional_buttons: [
              {
                type: 'base',
                appendIcon: 'mdi-refresh',
                disabled: this.invitationRefreshDisabled,
                click: async (event) => {
                  const { fetchTabData } = event || {}
                  this.invitationRefreshDisabled = true

                  await fetchTabData?.()
                  await this.fetchHistoryDocuments(DOCUMENT_TYPE, DOCUMENTS_HISTORY_DATA_KEY)

                  setTimeout(() => {
                    this.invitationRefreshDisabled = false
                  }, this.refreshTabBtnTimeout)
                }
              },
              {
                type: 'base',
                label: this.$t('fleet/documents/prl_cargo.change_status'),
                prependIcon: 'mdi-swap-horizontal',
                visible: !!this.permissions?.canChangeStatus,
                click: (event) => this.onChangeStatus(event)
              }
            ]
          },
          // Data for document generation
          {
            component: this.columnsContentComponent,
            title: this.$t('road-maintenance/aggregator.data_for_document_generation'),
            rows: [
              {
                type: 'fields',
                columnsCount: 3,
                fields: [
                  {
                    key: 'addresses',
                    label: this.$t('road-maintenance/aggregator.addresses'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'excavation_reason',
                    label: this.$t('road-maintenance/dropdown-types.excavation_reason'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'created_at',
                    appendIcon: 'mdi-calendar',
                    label: this.$t('road-maintenance/aggregator.document_date'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'consent_number',
                    label: this.$t('road-maintenance/excavation-service/tabs/approval/columns.consent_number'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'consent_date',
                    label: this.$t('road-maintenance/excavation-service/tabs/approval/columns.consent_date'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'repair_investor_name',
                    label: this.$t('road-maintenance/aggregator.investor_of_the_repair'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'contractor_name',
                    label: this.$t('road-maintenance/dropdown-types.contractor'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'repair_investor_responsible_person',
                    label: this.$t('road-maintenance/dropdown-types.repair_investor_responsible_person'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'contractor_responsible_person',
                    label: this.$t('road-maintenance/aggregator.contractor_responsible_person'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'is_road_authority_setter',
                    label: this.$t('road-maintenance/aggregator.prp_zg_roads'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'excavation_handover_date_time',
                    label: this.$t('road-maintenance/aggregator.handover_date_time'),
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'excavation_handover_note',
                    type: 'textarea',
                    label: this.$t('road-maintenance/aggregator.other_notes'),
                    creatable: false,
                    editable: false,
                    visible: true
                  }
                ]
              }
            ]
          },
          // Document history
          {
            component: this.rowBlocksDataComponent,
            mainClasses: 'aggregator-requests-blocks-main',
            wrapperClasses: 'aggregator-requests-subject-wrapper',
            title: this.$t('road-maintenance/aggregator.log_history'),
            visible: true,
            externalData: this.logsData,
            dataKey: DOCUMENTS_HISTORY_DATA_KEY,
            columnsConfig: [
              {
                key: 'created_at',
                valueClass: 'history-block-value',
                title: this.$t('road-maintenance.date') + ':',
                customValue: (data) => {
                  return data?.created_at ? dateService.formatCustom(data.created_at, FORMATS.isoDatetime, FORMATS.datetimeShort) : ''
                }
              },
              {
                key: 'status',
                valueClass: 'history-block-value',
                title: this.$t('road-maintenance/excavation-service.status') + ':',
                customValue: (data) => {
                  return data?.status ? this.$t(data.status) : '-'
                }
              },
              {
                key: 'user',
                valueClass: 'history-block-value',
                title: this.$t('road-maintenance.user') + ':'
              },
              {
                key: 'document',
                valueClass: 'history-block-value',
                visible: (event) => {
                  return event?.blockValue !== '-'
                },
                loaderIds: this.ithDocumentLoaders,
                title: this.$t('road-maintenance/aggregator.document') + ':',
                prependImage: {
                  src: '/img/icons/pdf-icon.svg',
                  style: {
                    marginRight: '4%'
                  }
                },
                contentWrapperStyle: {
                  display: 'flex',
                  alignItems: 'center'
                },
                customValue: (data) => {
                  return data?.document?.name ? data.document.name : '-'
                },
                click: (event) => this.onIthDownloadDocument(event)
              }
            ]
          }
        ]
      }
    }
  },

  methods: {
    async onIthDownloadDocument (event) {
      const { id: documentId } = event?.rowData || {}
      // skip if download is already in progress
      if (this.ithDocumentLoaders.includes(documentId)) {
        return
      }
      // show document loader
      if (documentId && !this.ithDocumentLoaders.includes(documentId)) {
        this.ithDocumentLoaders.push(documentId)
      }

      // download document
      await this.downloadDocument(event)
      // stop document loader
      if (this.ithDocumentLoaders.includes(documentId)) {
        this.ithDocumentLoaders = this.ithDocumentLoaders.filter(activeLoaderId => activeLoaderId !== documentId)
      }
    },

    async onInvitationHandoverDataFetched (event) {
      const { data: apiData, updateData } = event || {}
      const { formDataForSend } = event || {}

      const data = apiData?.data || formDataForSend || {}

      if (typeof updateData === 'function' && data && isObject(data)) {
        updateData({
          is_road_authority_setter: data?.is_road_authority_setter ? this.$t('base.yes') : this.$t('base.no')
        })
      }
      if (!this.invitationHandoverDocumentHistoryLoaded) {
        this.invitationHandoverDocumentHistoryLoaded = true
        await this.fetchHistoryDocuments(DOCUMENT_TYPE, DOCUMENTS_HISTORY_DATA_KEY)
      }
    }
  }
}
